import moment from 'moment';

export const STATUS_LABELS = {
  sent: 'Sent',
  scheduled: 'Scheduled',
  sending: 'Sending',
  cancelled: 'Cancelled',
};

export const formatDate = unixSeconds =>
  moment.unix(unixSeconds).format('MM/DD/YYYY');

// "Cancelled on 10/27/2026 by Jane Smith". Messages cancelled before
// cancelledBy was recorded have no name, so the "by" part is left out.
export const getCancelledText = ({ cancelledTime, cancelledByName }) => {
  if (!cancelledTime) return 'Cancelled';
  const text = `Cancelled on ${formatDate(cancelledTime)}`;
  return cancelledByName ? `${text} by ${cancelledByName}` : text;
};

// The emergency cancel link is shown while the queued send has not started.
export const isEmergencyCancelOpen = (message, nowSeconds) =>
  message.status === 'sending' && message.standbySendTime > nowSeconds;

// Minutes left before the queued send starts, to two decimals ("2.17").
export const getMinutesRemaining = (standbySendTime, nowSeconds) =>
  ((standbySendTime - nowSeconds) / 60).toFixed(2);
